<div
	class="flex place-self-stretch flex-1 justify-center items-center bg-gray-50"
>
	<img
		src="/assets/images/undraw/undraw_secure_login_0A6561.svg"
		class="w-[350px] w-full"
	/>
</div>

<div class="flex flex-col w-full h-full justify-between">
	<form #createFileForm="ngForm" class="flex-1 flex flex-col gap-6 p-6">
		<h5 class="text-sm font-medium">
			Matter Type
			<span class="pl-3 font-normal">{{ matterType | capitalize }}</span>
		</h5>

		<app-input
			name="fileName"
			label="Matter Name"
			[required]="true"
			[(ngModel)]="fileName"
			[submitted]="submitted"
			[testHook]="testHooks.FileName"
		></app-input>
		<app-input
			name="fileNumber"
			label="Matter #"
			[required]="true"
			[(ngModel)]="fileNumber"
			[submitted]="submitted"
			[testHook]="testHooks.FileNumber"
			[appUniqueMatterNumber]="true"
		></app-input>
		<div *ngIf="lastestMatter" class="text-sm font-medium">
			Last Matter #
			<span class="pl-3 font-normal">{{ lastestMatter?.number }}</span>
		</div>

		<app-acting-for-dropdown
			label="Acting for"
			[required]="matterType == matterTypes.REFINANCE"
			[(ngModel)]="actingFor"
			name="actingFor"
			[submitted]="submitted"
			*ngIf="matterType == matterTypes.REFINANCE"
		>
		</app-acting-for-dropdown>

		<hr />

		<app-dropdown
			name="assignedLawyer"
			label="Lawyer On Matter"
			[itemGroups]="[{ items: lawyers }]"
			(onSelect)="setLawyer($event)"
			[ngModel]="assignedLawyerName"
			[submitted]="submitted"
			[disabled]="disableLawyerSelect && assignedLawyer?.id"
			[testHook]="testHooks.AssignALawyerDropdown"
		></app-dropdown>
		<app-dropdown
			name="assignedClerk"
			label="Clerk On Matter"
			[itemGroups]="[{ items: clerks }]"
			(onSelect)="setClerk($event)"
			[ngModel]="assignedClerkName"
			[submitted]="submitted"
			[testHook]="testHooks.AssignAClerkDropdown"
		></app-dropdown>
		<div>
			<app-dropdown
				name="selectedOffice"
				label="Office Name"
				[itemGroups]="[{ items: officesSimpleProfiles_() }]"
				(onSelect)="onOfficeSelect($event)"
				[ngModel]="selectedOfficeDisplayName_()"
				[submitted]="submitted"
				[required]="true"
				[testHook]="testHooks.OfficeNameDropdown"
			></app-dropdown>
			<div
				*ngIf="showOfficialOfficeName_()"
				class="text-sm text-gray-500 font-normal mt-1"
			>
				Office Name (Official): {{ selectedOfficeOfficialName_() }}
			</div>
		</div>
		<atomic-message-bar
			type="error"
			*ngIf="error"
			[@openClose]
			class="mt-4"
			[testHook]="testHooks.MessageBar"
		>
			Unable to create matter. Please try again.
		</atomic-message-bar>
	</form>
	<div class="w-full justify-end flex gap-6 pb-4 pt-8 px-6">
		<ui-button
			(click)="cancel()"
			[style]="'outline'"
			[color]="'secondary'"
			[label]="'Back'"
			[disabled]="creating"
			[testHook]="testHooks.CancelButton"
		></ui-button>
		<ui-button
			(click)="submit(createFileForm)"
			preset="HIGH_EMPHASIS"
			label="Next"
			[loading]="creating"
			[disabled]="creating || !createFileForm.valid"
			[testHook]="testHooks.NextButton"
		></ui-button>
	</div>
</div>
